import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Component } from "react";
import swal from "sweetalert";
import DeliveraMenu, {
  DeliveraMenuInterface,
} from "../../../controller/model/delivera/DeliveraMenu";
import { DeliveraStore } from "../../../controller/model/delivera/DeliveraStore";

import { Add, Delete } from "@mui/icons-material";
import DeliveraCategory from "../../../controller/model/delivera/DeliveraCategorie";
import {
  DayOfWeekType,
  DeliveraServiceAvailabilityInterface,
  DeliveraTimePeriodInterface,
} from "../../../controller/model/delivera/interface";

interface StateInterface {
  menu: DeliveraMenu | undefined;
  isOpen: boolean;
  name: string;
  service: DeliveraServiceAvailabilityInterface[];
  categories: string[];
  categoryMenuElement: any;
}

interface PropsInterface {
  store: DeliveraStore;
  handleTapSave: (menu: DeliveraMenuInterface) => void;
}

const avaible_days = {
  monday: "lundi",
  tuesday: "mardi",
  wednesday: "mercredi",
  thursday: "jeudi",
  friday: "vendredi",
  saturday: "samedi",
  sunday: "dimanche",
};

export default class DeliveraMenuDetailModal extends Component {
  public state: StateInterface;
  public props: PropsInterface;

  constructor(props: any) {
    super(props);
    this.state = {
      menu: undefined,
      isOpen: false,
      name: "",
      service: [],
      categories: [],
      categoryMenuElement: null,
    };
    this.props = props;
    this.openModalWithMenu = this.openModalWithMenu.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.createMenu = this.createMenu.bind(this);
    this.handleUpdateServiceStartHourAtIndex = this.handleUpdateServiceStartHourAtIndex.bind(
      this
    );
    this.handleUpdateServiceEndHourAtIndex = this.handleUpdateServiceEndHourAtIndex.bind(
      this
    );
    this.handleUpdateServiceEndMinuteAtIndex = this.handleUpdateServiceEndMinuteAtIndex.bind(
      this
    );
    this.handleClickAddTimeOnService = this.handleClickAddTimeOnService.bind(
      this
    );
    this.handleClickDeleteTimeOnServiceAtIndex = this.handleClickDeleteTimeOnServiceAtIndex.bind(
      this
    );
  }

  public openModalWithMenu(menu: DeliveraMenu) {
    this.setState({
      menu: menu,
      isOpen: true,
      name: DeliveraStore.retreiveNameFromTranslation(menu.title),
      service: menu.service_availability,
      categories: menu.category_ids,
    });
  }

  public closeModal() {
    this.setState({
      menu: undefined,
      isOpen: false,
    });
  }

  private createMenu(): DeliveraMenuInterface {
    let menu = Object.assign({}, this.state.menu?.toJS());
    menu["title"] = {
      translations: {
        fr: this.state.name,
        en: this.state.name,
      },
    };
    menu["subtitle"] = { translations: { fr: "menu", en: "menu" } };
    menu["service_availability"] = this.state.service;
    menu["category_ids"] = this.state.categories;

    return menu as DeliveraMenuInterface;
  }

  private handleAddCategorieOnMenu(categorie: DeliveraCategory) {
    let cats = Array.from(this.state.categories);
    cats.push(categorie.id);
    this.setState({ categories: cats, categoryMenuElement: null });
  }

  private handleClickDeleteCategorieOnMenu(cat_id: string) {
    let cats = Array.from(this.state.categories);
    cats.splice(cats.indexOf(cat_id), 1);
    this.setState({ categories: cats });
  }

  render() {
    return (
      <div style={{ overflow: "scroll" }}>
        <Dialog
          open={this.state.isOpen}
          onClose={this.closeModal}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle style={{ backgroundColor: "#474F5E", color: "white" }}>
            {this.state.menu
              ? `Modification du Menu ${DeliveraStore.retreiveNameFromTranslation(
                  this.state.menu.title
                )}`
              : "Création d'une catégorie"}
          </DialogTitle>
          <DialogContent
            style={{ border: "1px solid #7ABF92", margin: "10px 20px" }}
          >
            <div
              style={{
                display: "inline-block",
                width: "100%",
              }}
            >
              <h3
                style={{
                  color: "#474F5E",
                  fontWeight: "bold",
                }}
              >
                Nom du Menu :
              </h3>
              <TextField
                fullWidth={true}
                value={this.state.name}
                variant="outlined"
                InputProps={{
                  style: {
                    color: "#474F5E",
                  },
                }}
                onChange={(event) => {
                  this.setState({
                    name: event.target.value,
                  });
                }}
              />
            </div>

            <div
              style={{
                width: "100%",
                display: "inline-block",
              }}
            >
              <h3
                style={{
                  color: "#474F5E",
                  fontWeight: "bold",
                }}
              >
                Catégorie du Menu :
              </h3>
              <hr />
              <div
                className="category_in_menu"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                {this.state.categories.map((cat_id, i) => {
                  const categories = this.props.store.categories.find(
                    (c) => c.id === cat_id
                  );
                  return (
                    <div key={i}>
                      <Fab
                        key={`categorie_${cat_id}`}
                        variant="extended"
                        size="medium"
                        aria-label="delete"
                        style={{
                          margin: "10px",
                          backgroundColor: "white",
                          color: "#474F5E",
                        }}
                        onClick={(_e) => {
                          this.handleClickDeleteCategorieOnMenu(cat_id);
                        }}
                      >
                        <div style={{ display: "flex", margin: "auto" }}>
                          {DeliveraStore.retreiveNameFromTranslation(
                            categories?.title
                          )}
                          <Delete
                            style={{ marginLeft: "10px", color: "#7ABF92" }}
                          />
                        </div>
                      </Fab>
                    </div>
                  );
                })}
                <Fab
                  variant="extended"
                  size="medium"
                  style={{
                    margin: "10px",
                    backgroundColor: "#7ABF92",
                    color: "white",
                  }}
                  aria-label="add"
                  onClick={(e) => {
                    this.setState({ categoryMenuElement: e.target });
                  }}
                >
                  <Add />
                </Fab>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.categoryMenuElement}
                  keepMounted
                  open={Boolean(this.state.categoryMenuElement)}
                  onClose={() => {
                    this.setState({ categoryMenuElement: null });
                  }}
                >
                  {this.props.store.categories.map((aCat, index) => {
                    return (
                      <MenuItem
                        key={index}
                        onClick={(_e) => {
                          this.handleAddCategorieOnMenu(aCat);
                        }}
                      >
                        {DeliveraStore.retreiveNameFromTranslation(aCat.title)}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
            </div>

            <div className="contentDiv" style={{ marginTop: "20px" }}>
              {Object.keys(avaible_days).map((aDay) => {
                const service = this.state.service.find(
                  (s) => s.day_of_week === aDay
                );
                const isActive =
                  service !== undefined && service.time_periods.length !== 0;
                return (
                  <div
                    id={aDay}
                    key={aDay}
                    style={{
                      margin: "5px",
                      backgroundColor: "#F1F1F5",
                      display: "flex",
                      border: "1px solid #7ABF92",
                      padding: "10px",
                    }}
                  >
                    <Checkbox
                      id={aDay}
                      color="primary"
                      checked={isActive}
                      onChange={(e) => {
                        this.handleTapDesactiveService(service, aDay);
                      }}
                      inputProps={{ "aria-label": "primary checkbox" }}
                      style={{ color: "#7ABF92" }}
                    />
                    <h4
                      style={{
                        width: "15%",
                        textTransform: "capitalize",
                        color: "#474F5E",
                        fontWeight: "normal",
                      }}
                    >
                      {(avaible_days as any)[aDay] as string}
                    </h4>
                    {isActive === true ? (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                          overflow: "scroll",
                          width: "75%",
                        }}
                      >
                        <div style={{ display: "inline-block", width: "100%" }}>
                          {service!.time_periods.map((atimeperiode, index) => {
                            const startTime = atimeperiode["start_time"];
                            const endTime = atimeperiode["end_time"];
                            return (
                              <div key={index} style={{ display: "flex" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    fontSize: "13px",
                                    color: "#474F5E",
                                    flexWrap: "wrap",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Horaire d'ouverture
                                  </span>
                                  <FormControl
                                    key="start_form_hour"
                                    style={{
                                      minWidth: "100",
                                      width: "100px",
                                      backgroundColor: "white",
                                    }}
                                    variant="outlined"
                                  >
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={startTime.split(":")[0]}
                                      onChange={(e) => {
                                        this.handleUpdateServiceStartHourAtIndex(
                                          service!,
                                          index,
                                          e.target.value as string
                                        );
                                      }}
                                      name={`${aDay}`}
                                    >
                                      {generateAvaibleHour().map((aHour) => {
                                        return (
                                          <MenuItem
                                            key={aHour}
                                            id={`${aHour}_${index}`}
                                            value={aHour}
                                          >
                                            {aHour}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                  <h4 style={{ color: "#474F5E" }}>{" : "}</h4>
                                  <FormControl
                                    key="start_form_minute"
                                    style={{
                                      minWidth: "100",
                                      width: "100px",
                                      backgroundColor: "white",
                                    }}
                                    variant="outlined"
                                  >
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={startTime.split(":")[1]}
                                      onChange={(e) => {
                                        this.handleUpdateServiceStartMinuteAtIndex(
                                          service!,
                                          index,
                                          e.target.value as string
                                        );
                                      }}
                                      name={`${aDay}`}
                                    >
                                      {generateAvaibleMinutes().map(
                                        (aMinute) => {
                                          return (
                                            <MenuItem
                                              key={aMinute}
                                              id={`${aMinute}_${index}`}
                                              value={aMinute}
                                            >
                                              {aMinute}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                <div
                                  style={{
                                    width: "20px",
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    fontSize: "13px",
                                    color: "#474F5E",
                                    flexWrap: "wrap",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Horaire de fermeture
                                  </span>
                                  <FormControl
                                    key="end_form_hour"
                                    style={{
                                      minWidth: "100",
                                      width: "100px",
                                      backgroundColor: "white",
                                    }}
                                    variant="outlined"
                                  >
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={endTime.split(":")[0]}
                                      onChange={(e) => {
                                        this.handleUpdateServiceEndHourAtIndex(
                                          service!,
                                          index,
                                          e.target.value as string
                                        );
                                      }}
                                      name={`${aDay}`}
                                    >
                                      {generateAvaibleHour().map((aHour) => {
                                        return (
                                          <MenuItem
                                            key={aHour}
                                            id={`${aHour}_${index}`}
                                            value={aHour}
                                          >
                                            {aHour}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                  <h4 style={{ color: "#474F5E" }}>{" : "}</h4>
                                  <FormControl
                                    key="end_form_minute"
                                    style={{
                                      minWidth: "100",
                                      width: "100px",
                                      backgroundColor: "white",
                                    }}
                                    variant="outlined"
                                  >
                                    <Select
                                      value={endTime.split(":")[1]}
                                      onChange={(e) => {
                                        this.handleUpdateServiceEndMinuteAtIndex(
                                          service!,
                                          index,
                                          e.target.value as string
                                        );
                                      }}
                                      name={`${aDay}`}
                                    >
                                      {generateAvaibleMinutes().map(
                                        (aMinute) => {
                                          return (
                                            <MenuItem
                                              key={aMinute}
                                              id={`${aMinute}_${index}`}
                                              value={aMinute}
                                            >
                                              {aMinute}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>

                                <Fab
                                  variant="extended"
                                  size="medium"
                                  style={{
                                    backgroundColor: "#474F5E",
                                    color: "white",
                                    alignSelf: "center",
                                    marginLeft: "10px",
                                    marginTop: "14px",
                                  }}
                                  aria-label="delete"
                                  onClick={(_e) => {
                                    this.handleClickDeleteTimeOnServiceAtIndex(
                                      service!,
                                      index
                                    );
                                  }}
                                >
                                  <Delete />
                                </Fab>
                              </div>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            width: "15%",
                            marginTop: "10px",
                            marginLeft: "25px",
                            textAlign: "end",
                          }}
                        >
                          <Fab
                            variant="extended"
                            size="medium"
                            style={{
                              backgroundColor: "#474F5E",
                              color: "white",
                              alignSelf: "center",
                              marginLeft: "10px",
                              marginTop: "10px",
                            }}
                            aria-label="delete"
                            onClick={(_e) => {
                              this.handleClickAddTimeOnService(service!);
                            }}
                          >
                            <Add />
                          </Fab>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                );
              })}
            </div>
          </DialogContent>
          <DialogActions style={{ margin: "20px" }}>
            <Button
              variant="contained"
              onClick={this.closeModal}
              color="primary"
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color="secondary"
              style={{ color: "white" }}
              onClick={(_) => {
                this.verifyTimeCreatedIsValid();
                // this.props.handleTapSave(this.createMenu());
              }}
            >
              Enregister
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  private handleClickAddTimeOnService(
    service: DeliveraServiceAvailabilityInterface
  ) {
    const indexService = this.state.service.findIndex(
      (s) => s.day_of_week === service.day_of_week
    );
    service.time_periods.push({
      start_time: "09:00",
      end_time: "20:00",
    });
    let servicesUpdated = Array.from(this.state.service);
    servicesUpdated[indexService] = service;
    this.setState({ service: servicesUpdated });
  }

  private handleClickDeleteTimeOnServiceAtIndex(
    service: DeliveraServiceAvailabilityInterface,
    index: number
  ) {
    const indexService = this.state.service.findIndex(
      (s) => s.day_of_week === service.day_of_week
    );
    service.time_periods.splice(index, 1);
    let servicesUpdated = Array.from(this.state.service);
    servicesUpdated[indexService] = service;
    this.setState({ service: servicesUpdated });
  }

  private handleUpdateServiceEndHourAtIndex(
    service: DeliveraServiceAvailabilityInterface,
    index: number,
    value: string
  ) {
    const indexService = this.state.service.findIndex(
      (s) => s.day_of_week === service.day_of_week
    );
    const oldTime = service.time_periods[index].end_time;
    const minute = oldTime.split(":")[1];
    let serviceUpdated = Object.assign({}, service);
    serviceUpdated.time_periods[index].end_time = `${value}:${minute}`;
    let servicesUpdated = Array.from(this.state.service);
    servicesUpdated[indexService] = serviceUpdated;
    this.setState({ service: servicesUpdated });
  }

  private handleUpdateServiceEndMinuteAtIndex(
    service: DeliveraServiceAvailabilityInterface,
    index: number,
    value: string
  ) {
    const indexService = this.state.service.findIndex(
      (s) => s.day_of_week === service.day_of_week
    );
    const oldTime = service.time_periods[index].end_time;
    const hour = oldTime.split(":")[0];
    let serviceUpdated = Object.assign({}, service);
    serviceUpdated.time_periods[index].end_time = `${hour}:${value}`;
    let servicesUpdated = Array.from(this.state.service);
    servicesUpdated[indexService] = serviceUpdated;
    this.setState({ service: servicesUpdated });
  }

  private handleUpdateServiceStartHourAtIndex(
    service: DeliveraServiceAvailabilityInterface,
    index: number,
    value: string
  ) {
    const indexService = this.state.service.findIndex(
      (s) => s.day_of_week === service.day_of_week
    );
    const oldTime = service.time_periods[index].start_time;
    const minutes = oldTime.split(":")[1];
    let serviceUpdated = Object.assign({}, service);
    serviceUpdated.time_periods[index].start_time = `${value}:${minutes}`;
    let servicesUpdated = Array.from(this.state.service);
    servicesUpdated[indexService] = serviceUpdated;
    this.setState({
      service: servicesUpdated,
    });
  }

  private handleUpdateServiceStartMinuteAtIndex(
    service: DeliveraServiceAvailabilityInterface,
    index: number,
    value: string
  ) {
    const indexService = this.state.service.findIndex(
      (s) => s.day_of_week === service.day_of_week
    );
    const oldTime = service.time_periods[index].start_time;
    const hours = oldTime.split(":")[0];
    let serviceUpdated = Object.assign({}, service);
    serviceUpdated.time_periods[index].start_time = `${hours}:${value}`;
    let servicesUpdated = Array.from(this.state.service);
    servicesUpdated[indexService] = serviceUpdated;
    this.setState({
      service: servicesUpdated,
    });
  }

  private handleTapDesactiveService(
    service: DeliveraServiceAvailabilityInterface | undefined,
    day: string
  ) {
    if (undefined === service) {
      let updatedServices = Array.from(this.state.service);
      updatedServices.push({
        day_of_week: day as DayOfWeekType,
        time_periods: [
          {
            start_time: "09:00",
            end_time: "23:00",
          },
        ],
      });
      this.setState({ service: updatedServices });
    } else {
      const index = this.state.service.findIndex(
        (s) => s.day_of_week === service?.day_of_week ?? ""
      );
      if (service.time_periods.length === 0) {
        let serviceUpdated = Object.assign({}, service);
        serviceUpdated.time_periods = [
          {
            start_time: "09:00",
            end_time: "23:00",
          },
        ];
        let servicesUpdated = Array.from(this.state.service);
        servicesUpdated[index] = serviceUpdated;
        this.setState({
          service: servicesUpdated,
        });
      } else {
        let serviceUpdated = Object.assign({}, service);
        serviceUpdated.time_periods = [];
        let servicesUpdated = Array.from(this.state.service);
        servicesUpdated[index] = serviceUpdated;
        this.setState({
          service: servicesUpdated,
        });
      }
    }
  }

  private verifyTimeCreatedIsValid() {
    let isCorrect = true;
    let day: string = "";
    this.state.service.forEach((aService) => {
      aService.time_periods.forEach((aTimePeriode) => {
        const aTimeToVerify: DeliveraTimePeriodInterface = aTimePeriode;
        aService.time_periods.forEach((aTime) => {
          const hourStart = parseInt(aTime.start_time.split(":")[0]);
          // const minuteStart = parseInt(aTime.start_time.split(':')[1]);
          const hourEnd = parseInt(aTime.end_time.split(":")[0]);
          // const minuteEnd = parseInt(aTime.end_time.split(':')[1]);
          const hourStartToVerify = parseInt(
            aTimeToVerify.start_time.split(":")[0]
          );
          // const minutesStartToVerify = parseInt(aTimeToVerify.start_time.split(':')[1]);
          const hourEndToVerify = parseInt(
            aTimeToVerify.end_time.split(":")[0]
          );
          // const minuteEndToVerify = parseInt(aTimeToVerify.end_time.split(':')[1]);

          if (hourStart > hourStartToVerify) {
            if (hourEnd > hourEndToVerify) {
              // console.log(aService.day_of_week, "est OK");
            } else {
              day = aService.day_of_week;
              isCorrect = false;
            }
          } else if (hourStart < hourStartToVerify) {
            if (hourEnd < hourEndToVerify) {
              // console.log(aService.day_of_week, "est OK");
            } else {
              day = aService.day_of_week;
              isCorrect = false;
            }
          } else if (
            hourStart === hourStartToVerify &&
            hourEndToVerify === hourEnd
          ) {
            // console.log("check des meme horaire");
          }
          // else if (hourStart === hourStartToVerify) {
          //     if (minuteStart > minutesStartToVerify) {
          //         if (hourEnd > hourEndToVerify) {
          //             console.log(aService.day_of_week, 'est OK');
          //         } else if
          //     }
          //     else {

          //     }
          // }
          else {
            day = aService.day_of_week;
            isCorrect = false;
          }
        });
      });
    });

    if (isCorrect === true) {
      this.props.handleTapSave(this.createMenu());
      return;
    } else {
      swal({
        title: `Impossible`,
        text: `Des horaires se chevauchent sur la journée de ${
          (avaible_days as any)[day]
        }`,
        icon: "warning",
        buttons: ["OK"],
        dangerMode: true,
      })
        .then((_v) => {
          return;
        })
        .catch((e) => {
          console.warn(e);
          return;
        });
    }
  }
}

const generateAvaibleHour = () => {
  let hours = [];
  for (let i = 0; i < 24; i++) {
    const hourString = `${i}`;
    const hour = hourString.length === 1 ? `0${hourString}` : `${hourString}`;
    hours.push(hour);
  }

  return hours;
};

const generateAvaibleMinutes = () => {
  let minutes = [];
  for (let i = 0; i < 60; i++) {
    const minuteString = `${i}`;
    const minute = minuteString.length === 1 ? `0${i}` : `${i}`;
    minutes.push(minute);
  }
  return minutes;
};

// const _generateAvaibleTime = () => {
//     let time = [];
//     for(let i=1; i<24; i++ ) {
//         const hourString = `${i}`;
//         const hour = (hourString.length === 1) ? `0${hourString}` : `${hourString}`;
//         for (let j=0; j<60; j++) {
//             const minuteString = `${j}`;
//             const minute = (minuteString.length === 1) ? `0${j}` : `${j}`;

//             time.push(`${hour}:${minute}`);
//         }
//     }

//     return time;
// };
